<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Model Name</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-3">
              <label for="name" class="form-label">Model Name</label
              ><input
                type="text"
                id="name"
                minlength="3"
                maxlength="50"
                class="form-control"
                v-model="name"
                @keyup="validate"
              />
              <small class="text-secondary">
                <i>Must be at least 3 characters</i></small
              >
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label for="ref" class="form-label">Reference</label>
              <input
                type="text"
                id="ref"
                class="form-control"
                v-model="ref"
                disabled
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label for="region" class="form-label">Type</label>
              <input
                type="text"
                id="type"
                class="form-control"
                v-model="type"
                disabled
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-primary w-100"
                :disabled="!valid_input"
                @click="update_model"
              >
                Update Model
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Storage from "../../helpers/storage";

export default {
  name: "ModelName",
  props: ["id"],
  data() {
    return {
      ref: "",
      name: "",
      type: "",
      valid_input: false,
    };
  },
  mounted() {
    this.emitter.on("model_details_loaded", (data) => {
      this.ref = data.ref ? data.ref : "";
      this.name = data.name ? data.name : "";
      this.type = data.type ? data.type : "";

      this.validate();
    });
  },
  methods: {
    validate() {
      this.valid_input = this.name.length >= 3;
    },

    update_model() {
      var sessionTokens = Storage.get("session_tokens", true),
        axeTokens = Storage.get("tokens");

      axios
        .patch(
          process.env.MIX_APP_URL + "/api/v1/models/" + this.ref,
          {
            name: this.name,
          },
          {
            headers: {
              Authorization:
                sessionTokens.token_type + " " + sessionTokens.access_token,
              "RT-Authorization": axeTokens.access_token,
            },
          }
        )
        .then(
          (response) => {
            if (200 === response.status) {
              this.emitter.emit("model_details_updated");

              let modelNameModal = bootstrap.Modal.getInstance(
                document.getElementById(this.id)
              );
              modelNameModal.hide();

              this.emitter.emit("popup_alert", {
                type: "success",
                text: "Model name was succesfuly updated!",
              });
            }
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>